// extracted by mini-css-extract-plugin
export default {"field":"GCzr9","removeButton":"uHckz","input":"m9sHs","tooltipClickInfo":"NAXcn"};